<template>
  <b-modal 
    v-model="showModal" 
    :title="$t('Add Admin Images')" 
    @ok="handleUpload"
    @hidden="resetModal"
    size="md"
    :busy="uploadingImages"
    :ok-disabled="!newImages || newImages.length === 0 || uploadingImages"
    :ok-title="uploadingImages ? $t('Uploading...') : $t('Upload Images')"
    :cancel-title="$t('Cancel')"
    body-class="pb-3"
    header-class="border-bottom"
    footer-class="border-top"
    no-fade>
    <div class="form-group mb-0">
      <label for="globalAdminImages">{{ $t('Upload Images') }}</label>
      <b-form-file
        id="globalAdminImages"
        v-model="newImages"
        multiple
        accept="image/*"
        :placeholder="$t('Choose images...')"
      ></b-form-file>
      <small class="text-muted">{{ $t('You can select multiple images') }}</small>
    </div>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'GlobalImageUploadModal',
  computed: {
    ...mapGetters(['apiUrl'])
  },
  data () {
    return {
      showModal: false,
      uploadingImages: false,
      newImages: null,
      uploadContext: {
        reportId: null,
        questionId: null,
        callback: null
      }
    }
  },
  mounted () {
    // Listen for upload requests
    this.$root.$on('open-image-upload-modal', this.openModal)
  },
  beforeDestroy () {
    this.$root.$off('open-image-upload-modal', this.openModal)
  },
  methods: {
    openModal (context) {
      this.uploadContext = context
      this.showModal = true
    },
    resetModal () {
      this.newImages = null
      this.uploadingImages = false
      this.uploadContext = {
        reportId: null,
        questionId: null,
        callback: null
      }
    },
    async handleUpload (bvModalEvt) {
      // Prevent modal from closing until upload completes
      bvModalEvt.preventDefault()

      if (!this.newImages || this.newImages.length === 0) return

      this.uploadingImages = true
      try {
        // Create FormData for file upload
        const formData = new FormData()
        formData.append('question_id', this.uploadContext.questionId)

        // Add multiple images
        if (Array.isArray(this.newImages)) {
          this.newImages.forEach(image => {
            formData.append('images[]', image)
          })
        } else {
          formData.append('images[]', this.newImages)
        }

        const response = await this.$http.post(`risk-report/${this.uploadContext.reportId}/upload-images`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })

        if (response.status === 200) {
          this.$notify({
            group: 'full',
            text: response.data.msg,
            type: 'success'
          })

          // Call the callback function to update the local component
          if (this.uploadContext.callback) {
            // Handle both response formats: uploaded_images (admin upload) and image_paths (temp upload)
            const imagePaths = response.data.uploaded_images || response.data.image_paths
            console.log('Calling callback with images:', imagePaths)
            this.uploadContext.callback(imagePaths)
          }

          // Close modal after successful upload and callback
          this.showModal = false
        }
      } catch (error) {
        this.$notify({
          group: 'full',
          text: (error.response && error.response.data && error.response.data.msg) || this.$t('Failed to add images'),
          type: 'error'
        })
      } finally {
        this.uploadingImages = false
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// GlobalImageUploadModal.vue?fa272f1a